<template>
    <section>
        <div id="features" ref="featuresRef" class="container">
            <div class="text-title">Key Features</div>
            <p v-if="productLine.featureDescription" class="q-pb-lg">
                {{ productLine.featureDescription }}
            </p>
            <div class="row q-col-gutter-lg items-stretch">
                <div v-for="feature in productLine.features" :key="feature.title"
                     class="col-xs-12">

                    <q-card>
                        <q-dialog :ref="feature.image">
                            <q-card class="bg-dark" style="width: max-content; max-width: 100vw;">
                                <q-card-section class="row items-center text-white justify-between" :class="{'q-py-xs' : screenSize.gt.sm, 'q-py-sm' : screenSize.lt.md}">   
                                    <span v-html="feature.title"  />
                                    <q-btn class="gt-sm" icon="mdi-close" flat round dense v-close-popup />
                                </q-card-section>
                                <q-card-section class="q-pa-none text-center">
                                    <img :src="feature.image" class="q-px-md q-pb-md">
                                </q-card-section>
                            </q-card>

                        </q-dialog>
                        <q-card-section :horizontal="screenSize.gt.sm" class="q-pa-none">
                            <q-card-section class="col-7" :class="{'q-pa-lg' : screenSize.gt.sm, 'q-px-lg q-pt-lg q-pb-sm' : screenSize.sm, 'q-px-md q-pt-md q-pb-none' : screenSize.xs, }">
                                <div class="text-subtitle1" v-html="feature.title" />
                                <div class="q-mt-md" v-html="feature.description" />
                            </q-card-section>
                            <!--<q-separator vertical inset class="q-my-md" />-->
                            <img @click="showScreenshot(feature)" v-if="screenSize.gt.sm" :src="feature.image" class="img-feature zoom" :class="{'q-pa-lg' : !screenSize.xs, 'q-pa-md' : screenSize.xs}">
                        </q-card-section>
                        <img @click="showScreenshot(feature)" v-if="screenSize.lt.md" :src="feature.image" class="img-feature zoom" :class="{'q-pa-lg' : !screenSize.xs, 'q-pa-md' : screenSize.xs}">

                    </q-card>
                </div>
            </div>
            <div class="text-caption text-grey q-mt-lg">
                *AutoCAD is a registered trademark of Autodesk, Inc.<br />
                **Acrobat and PDF are registered trademarks of Adobe Systems Incorporated.<br />
                <span v-if="productLine.name !== 'PlumbingCAD' && productLine.name !== 'F280'">ACCA, Manual J and Powered by ACCA Manual J are registered trademarks of the Air Conditioning Contractors of America. All rights reserved.<br /></span>
                <span v-if="productLine.name !== 'PlumbingCAD' && productLine.name !== 'ACCA'">CSA and F280 are trademarks owned by, and CSA F280-12 is copyrighted by, the Canadian Standards Association. All rights reserved.<br /></span>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'features',
        props: {
            productLine: Object,
        },
        data() {
            return {

            }
        },
        methods: {
            showScreenshot(feature) {
                if (feature?.image.includes('acca-powered')) {
                    this.$router.push('/acca')
                    return
                }
                else if (feature?.image.includes('f280-verified')) {
                    this.$router.push('/f280')
                    return
                }
                this.$refs[feature.image][0].show()
            }
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
        mounted() {
            if (this.$route.hash == '#features')
                setTimeout(() => {
                    this.scrollToElement(this.$refs.featuresRef)
                }, 100)

        }

    }
</script>
<style lang="scss" scoped>
    @import "../styles/quasar.variables.scss";

    .zoom {
        cursor: -moz-zoom-in;
        cursor: -webkit-zoom-in;
        cursor: zoom-in;
    }

    .img-feature {
        max-height: 300px;
        min-width: 300px;
        width: unset !important;
        object-fit: contain;
        margin: auto;
    }

    @media (max-width: $breakpoint-xs-max) {
        .img-feature {
            min-width: 0 !important;
        }
    }
</style>


